import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
// import edit from "../../Assets/svg/edit-icon.svg";
import tick from "../../Assets/svg/green-bg-tick.svg";

import StaticItem from "../modules/StaticItem";
import photo from "../../Assets/svg/photo.svg";
// import AddressColumn from "./AddressColumn";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../modules/ERcomponent";
import StaticData from "../modules/StaticData";
import edit from "../../Assets/svg/edit icon2.svg";
import BtnSet from "../IdfcLetterHead/BtnSet";
import Input from "../modules/Input";
import { modifySpoc } from "../DisburseForm/redux/actions";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import StaticField from "../StaticField";

function SpocColumn(props) {
  const eduInfo = useSelector((state) => state.education.eduInfo);
  const spoc = useSelector((state) => state.spoc.pageInfo);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const navigate = useNavigate();

  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const [isEdit, setEdit] = useState(false);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const dispatch = useDispatch();
  const [ModalData, setModalData] = useState({
    show: false,
    type: "",
    title: "Are you sure you would like leave?",
    countDown: " ",
    desc: "All your progress has been saved.",
  });
  const CombineData = () => {
    let data = {
      sfdcStudentId: null,
      campusName: spoc.campus || eduInfo?.campusSpecific,
    };
    let panCardInfo = null;
    let spocInfo = {
      firstName: spoc.firstName,
      lastName: spoc.lastName,
      email: spoc.email,
      phone: spoc.mobile,
    };
    let bankDetails = null;
    if (!tokenData?.totalLoginResponse?.collegeBankDetailsUpdated) {
      bankDetails = {
        name: spoc.bankName,
        accountName: spoc.accName,
        accountNumber: spoc.accNo,
        branchName: spoc.branchName,
        ifscCode: spoc.ifscCode,
      };
    }
    data = {
      ...data,
      panCardInfo: panCardInfo,
      spocInfo: spocInfo,
      bankDetails: bankDetails,
    };

    return data;
  };
  const submitData = async () => {
    try {
      const users = await api.collegeEmpanelment(
        CombineData(),
        tokenData.token,
        tokenData.applicationData.id
      );
      return users;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  };
  const appSubmit = async () => {
    try {
      const users = await submitData();
      return users;
    } catch (err) {
      console.log("err", err);
    }
  };
  const sendSpoc = async () => {
    console.log("in spoc", ModalData.type);
    if (ModalData.type === "") {
      setModalData({
        show: true,
        type: "confirm",
        title: "Are you sure you would like submit the form",
        countDown: " ",
        desc: "Once submitted, you can’t change the college bank account details",
      });
    } else if (ModalData.type === "confirm") {
      try {
        setLoading(true);
        let users = await appSubmit();
        if (users?.statusCode == 200) {
          setLoading(false);
          // else if (ModalData.type === "confirm") {
          setModalData({
            ...ModalData,
            show: true,
            title: "",
            desc: "",
            type: "submit",
          });

          setAlert(true);
          setTimeout(() => setAlert(false), 3000);
        } else {
          setLoading(false);
          // alert("Sorry! Something went wrong. Kindly Submit again.");
        }
      } catch (e) {
        alert("Sorry! Something went wrong. Kindly Submit again.");
      }
    } else if (ModalData.type === "submit") {
      setModalData({
        show: false,
        type: "",
        title: "",
        countDown: " ",
        desc: "",
      });
      // dispatch(addTokenInfo(["showSpoc", true]));
      // dispatch(addTokenInfo(["showBank", true]));
      let url = GetBaseUrl(window.location.href);
      navigate("/application/submitted-status");
    } else if (ModalData.type === "cancel") {
      let url = GetBaseUrl(window.location.href);
      navigate("/application/submitted-status");
      // window.location.replace(url + "/application/submitted-status");
    } else {
      setModalData({ ...ModalData, show: false });
      setLoading(true);
    }
  };
  const getValidDate = (date) => {
    if (!date.split("-")[1]) {
      date = `${date}-01-01`;
    } else if (date?.split("-")[0]?.length > 2) {
      date = date.split("-").reverse().join("-");
    }
    return date;
  };
  const addData = (type, data) => {
    dispatch(modifySpoc([type, data]));
  };

  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    console.log("cleaned url", cleanedUrl);
    // setLink(cleanedUrl);
    // checkLogin()
  }, []);
  console.log("personalInfo", personalInfo);
  return (
    <div className="personal-col review-col spoc-col">
      {/* </div> */}
      <div
        className={`${
          eduInfo?.campusSpecific === "Others" ? "set-title" : "form-title"
        }`}
      >
        {eduInfo?.campusSpecific === "Others"
          ? "SPOC Details"
          : "My College SPOC details"}
        {!isEdit && (
          <img onClick={() => setEdit((prev) => !prev)} src={edit} alt="edit" />
        )}
      </div>
      <div className="col">
        <div className="left-col">
          {isEdit ? (
            <Input
              placeholder={"First Name"}
              value={spoc.firstName}
              onChange={(e) =>
                addData("firstName", e.replace(/[^a-zA-Z]/g, ""))
              }
            />
          ) : (
            <StaticData title={"First Name"} value={spoc.firstName} />
          )}
          {isEdit ? (
            <Input
              placeholder={"Last Name"}
              value={spoc.lastName}
              onChange={(e) => addData("lastName", e.replace(/[^a-zA-Z]/g, ""))}
            />
          ) : (
            <StaticData title={"Last Name"} value={spoc.lastName} />
          )}
          {/* <StaticItem title={"Last Name"} value={personalInfo?.lastName} /> */}
          {isEdit ? (
            <Input
              placeholder={"Email"}
              value={spoc.email}
              type={"password"}
              id={"password"}
              onChange={(e) => addData("email", e)}
            />
          ) : (
            <StaticField mask={true} title={"Email"} value={spoc.email} />
          )}

          {isEdit ? (
            <Input
              placeholder={"Mobile Number"}
              value={spoc.mobile}
              type={"password"}
              id={"password"}
              onChange={(e) =>
                addData("mobile", e.replace(/\D/g, "").slice(0, 10))
              }
            />
          ) : (
            <StaticField
              mask={true}
              title={"Mobile Number"}
              value={spoc.mobile}
            />
          )}
          {isEdit && (
            <div className="btn-col">
              <Button
                // disabled={Err}
                onClickHandler={() => setEdit((prev) => !prev)}
                type={"contained override"}
                value={"Cancel"}
              />
              <Button
                // disabled={Err}
                onClickHandler={() => sendSpoc()}
                type={"contained"}
                value={"Save"}
              />
            </div>
          )}
        </div>
        <div className="left-col">
          <StaticData
            title={"College"}
            value={tokenData.registrationData.college}
          />
          {/* <StaticItem title={"Last Name"} value={personalInfo?.lastName} /> */}
          <StaticData title={"City"} value={eduInfo.city} />
          <StaticData title={"Campus"} value={eduInfo?.campusSpecific} />
          {props.others && (
            <StaticData title={"Other Campus"} value={spoc.campus} />
          )}
        </div>
      </div>
      {/* <AddressColumn /> */}
      {ModalData.show && (
        <ModalComponent
          className={"disburse-model"}
          show={ModalData.show && !loading}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          noCross={ModalData.type === "submit" && true}
          // countDown={ModalData.countDown}
        >
          {ModalData.type === "submit" ? (
            <div className="modal-set">
              <div>
                <img src={tick} alt="tick" />
              </div>
              <div className="md-title">
                Your Document has been uploaded successfully!
              </div>
              {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
              <div className="modal-btn-set">
                <Button
                  onClickHandler={() => sendSpoc()}
                  type={"contained "}
                  value={ModalData.type === "confirm" ? "Yes, Submit" : "Yes"}
                />
              </div>
            </div>
          ) : (
            <div className="modal-btn-set">
              <Button
                onClickHandler={() =>
                  setModalData({
                    ...ModalData,
                    show: false,
                    title: "",
                    desc: "",
                    type: "",
                  })
                }
                type={"contained override"}
                value={"No"}
              />
              <Button
                onClickHandler={() => sendSpoc()}
                type={"contained "}
                value={
                  ModalData.type === "confirm"
                    ? "Yes, Submit"
                    : ModalData.type === "cancel"
                    ? "Yes"
                    : "Okay"
                }
              />
            </div>
          )}
        </ModalComponent>
      )}
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default SpocColumn;
